<template>
    <div class="logo-container" v-if="whatsapp_number">
        <a :href="'https://api.whatsapp.com/send?phone=55'+ whatsapp_number" target="_blank">
            <img src="@/assets/imgs/whatsapp.svg" alt="WhatsApp logo"/>
        </a>
    </div>
</template>

<script>
export default {
    name: "WhatsAppFloater",
    computed: {
        whatsapp_number: function () {
            return process.env.VUE_APP_WHATSAPP_NUMBER;
        },
    },
}
</script>

<style>
.logo-container {
    position: fixed;
    right: 100px;
    bottom: 20px;
}

@media (max-width: 1024px) {
    .logo-container {
        right: 20px;
    }
}
</style>
